export const statiDomandaTCB={
  bozza: 0,
  inoltrata: 10,
  inGestione: 11,
  chiusaConEsitoPositivo: 12,
  chiusaConEsitoNegativo: 13,
  richiestaAnnullataCittadino: 14,
  storicoEsperienzaLavoratore: 9
};